import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { getUsersLoggedIn } from '@collections/users';
import { AuthService } from '@core/auth';
import { LayoutConfig, LayoutPrivileges } from '@layout/layout.abstract.config';
import { User } from '@shared';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';

@Component({
  selector: 'mojo-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent {
  @Input() isEnabledForPBIUser: boolean;
  currentUser$: Observable<User> = this.store.select(getUsersLoggedIn);
  initials$: Observable<string> = this.currentUser$.pipe(
    filter((currentUser) => !!currentUser),
    map((currentUser) => currentUser.firstName[0] + currentUser.lastName[0]),
  );
  avatarPhotoShape = AvatarShapes.circle;
  avatarBackground = AvatarBackgroundSizes.cover;
  privileges: LayoutPrivileges;
  apiKeyFE = AppFeatureExtensions.API_KEY;

  constructor(
    private store: Store<{}>,
    private layoutConfig: LayoutConfig,
    private authService: AuthService,
  ) {
    this.privileges = layoutConfig.privileges;
  }

  logout(event: any) {
    event.preventDefault();
    return this.authService.logout();
  }
}
